import {
    IonButton,
    IonCard,
    IonContent,
    IonFooter,
    IonPage,
    useIonRouter,
} from "@ionic/react";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { HeaderComponent } from "../../components";
import { useDispatch } from "react-redux";
import { useUsername } from "../../components/hooks";
import { setShowOnBoardingFlow } from "../../redux/actions/appStatus";
import { routes } from "../../route/constants";

export const OnBoardingTimerSettings: FC = () => {
    const { t } = useTranslation();
    const route = useIonRouter();
    const username = useUsername();
    const dispatch = useDispatch();

    const handleNextClicked = () => {
        dispatch(setShowOnBoardingFlow(false));
        return route.push(
            routes.onBoardingSetupComplete,
            "root",
            "replace"
        );
    };

    return (
        <IonPage>
            <HeaderComponent
                titleTestId="timer-settings-header"
                title={t("settings.TimerSettings.title")}
                showProgressBar={true}
                progressValue={0.5}
            />
            <IonContent>
                <IonCard style={{ marginTop: 0 }} color="transparent"></IonCard>
            </IonContent>
            <IonFooter>
                <IonButton
                    data-testid="timer-settings-next-button"
                    expand="block"
                    onClick={() => handleNextClicked()}
                >
                    {t("general.next")}
                </IonButton>
            </IonFooter>
        </IonPage>
    );
};
